import type { IconSvgObject } from './types';

const SaudiRiyalIcon: IconSvgObject = [
  ["path", { d: "M10 3V17.2792C10 17.7097 9.72457 18.0918 9.31623 18.2279L4 20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M14 3V16C14 16.6506 14.6114 17.1279 15.2425 16.9701L20 15.7808", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14 21L20 19.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M5 15L20 11", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default SaudiRiyalIcon;
